import { useEffect, useRef, useState } from 'react';
import { instrumentApi } from '../../../../utils/api';

const MIN_QUERY_LENGTH = 1;

export default function useInsightSuggest(query, { debounceMs = 300, enabled = true } = {}) {
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(false);
    const requestId = useRef(0);

    useEffect(() => {
        const trimmed = (query || '').trim();
        if (!enabled || trimmed.length < MIN_QUERY_LENGTH) {
            setSuggestions([]);
            setLoading(false);
            return undefined;
        }
        const id = ++requestId.current;
        const handle = setTimeout(async () => {
            setLoading(true);
            try {
                const res = await instrumentApi.suggest({ q: trimmed });
                if (id !== requestId.current) return;
                setSuggestions(Array.isArray(res?.suggestions) ? res.suggestions : []);
            } catch {
                if (id !== requestId.current) return;
                setSuggestions([]);
            } finally {
                if (id === requestId.current) setLoading(false);
            }
        }, debounceMs);
        return () => clearTimeout(handle);
    }, [query, debounceMs, enabled]);

    return { suggestions, loading };
}
